module.exports = __webpack_public_path__ + "img-front/register/logo.f20ed652.svg";